
import React, { useRef, useState, useEffect, useCallback } from 'react';
import {
  Modal,
  Button,
  Radio,
  Space,
  Slider,
  Tooltip,
  Card,
  Row,
  Col,
  Typography,
  Dropdown,
  // Checkbox,
  message,
} from 'antd';
import {
  ZoomInOutlined,
  ZoomOutOutlined,
  PushpinOutlined,
  // UndoOutlined,
  DeleteOutlined,
  // CheckOutlined,
  // SaveOutlined,
  BorderOutlined,
  SaveOutlined,
  MoreOutlined,
  // EyeOutlined,
  // EyeInvisibleOutlined,
  // FullscreenOutlined,
  // FullscreenExitOutlined,
  // MinusCircleOutlined,
  // CloseCircleOutlined,
  // SelectOutlined,
} from '@ant-design/icons';
import { useResponsive } from '../../../responsive/ResponsiveContext';
import './style.scss';
// import video from '../../../assets/Nexpyn-frame-seg.mp4';

const { Title, Text } = Typography;

type Point = { x: number; y: number };
type Polygon = Point[];

// const Magnifier: React.FC<{
//   image: HTMLImageElement | null;
//   visible: boolean;
//   mouseScreenPosition: Point;
//   offset: Point;
//   scale: number;
//   zoom: number;
//   size: number;
//   drawPolygon: any;
//   layers: any;
//   currentPolygon: Polygon;
//   mode: string;
// }> = ({
//   image,
//   visible,
//   mouseScreenPosition,
//   offset,
//   scale,
//   zoom,
//   size,
//   layers,
//   drawPolygon,
//   currentPolygon,
//   mode,
// }) => {
//     const canvasRef = useRef<HTMLCanvasElement>(null);
//     // const animationRef = useRef<number>(null);

//     useEffect(() => {
//       if (!image || !canvasRef.current || !visible) {
//         return;
//       }

//       const canvas = canvasRef.current;
//       const ctx = canvas.getContext('2d');
//       if (!ctx) {
//         return;
//       }

//       const sx =
//         (mouseScreenPosition.x - offset.x - size / (2 * zoom)) / scale;
//       const sy =
//         (mouseScreenPosition.y - offset.y - size / (2 * zoom)) / scale;
//       const sw = size / zoom / scale;
//       const sh = size / zoom / scale;

//       ctx.clearRect(0, 0, size, size);
//       ctx.save();
//       ctx.beginPath();
//       ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
//       ctx.clip();

//       ctx.drawImage(image, sx, sy, sw, sh, 0, 0, size, size);

//       Object.entries(layers).forEach(([, layer]: any) => {
//         if (layer.visible) {
//           layer.polygons.forEach((polygon: Point[]) => {
//             const adjustedPolygon = polygon.map((point) => ({
//               x: ((point.x - sx) / sw) * size,
//               y: ((point.y - sy) / sh) * size,
//             }));
//             drawPolygon(ctx, adjustedPolygon, layer.fillColor, layer.color);
//           });
//         }
//       });

//       if (currentPolygon.length > 0 && mode !== 'pan') {
//         const currentColor = mode === 'frame'
//           ? { stroke: '#FF4D4F', fill: 'rgba(255, 77, 79, 0.25)' }
//           : { stroke: '#1890FF', fill: 'rgba(24, 144, 255, 0.25)' };

//         const adjustedCurrent = currentPolygon.map((point) => ({
//           x: ((point.x - sx) / sw) * size,
//           y: ((point.y - sy) / sh) * size,
//         }));

//         drawPolygon(ctx, adjustedCurrent, currentColor.fill, currentColor.stroke, true);
//       }

//       ctx.restore();

//       ctx.beginPath();
//       ctx.arc(size / 2, size / 2, size / 2 - 1, 0, Math.PI * 2);
//       ctx.strokeStyle = '#000';
//       ctx.lineWidth = 1.5;
//       ctx.stroke();
//     }, [image, mouseScreenPosition, offset, scale, zoom, size, visible, layers, drawPolygon, currentPolygon, mode]);


//     if (!visible) {
//       return null;
//     }

//     return (
//       <canvas
//         ref={canvasRef}
//         width={size}
//         height={size}
//         style={{
//           position: 'absolute',
//           left: mouseScreenPosition.x - size / 2,
//           top: mouseScreenPosition.y - size / 2,
//           borderRadius: '50%',
//           pointerEvents: 'none',
//           zIndex: 100,
//           boxShadow: '0 0 10px rgba(0,0,0,0.5)',
//           transition: 'transform 0.03s linear',
//           willChange: 'transform',
//         }}
//       />
//     );
//   };

// interface AnnotationLayer {
//   polygons: Polygon[];
//   color: string;
//   fillColor: string;
//   label: string;
//   visible: boolean;
// }

interface AnnotationData {
  frame: Polygon[];
  support: Polygon[];
}

interface ImageAnnotationToolProps {
  visible: boolean;
  onClose: () => void;
  imageUrl: string;
  initialAnnotations?: {
    frame?: Polygon[];
    support?: Polygon[];
  };
  onSubmit?: (annotations: AnnotationData) => void;
  maxZoom?: number;
  minZoom?: number;
  title?: string;
  notes?: string;
  onNotesChange?: (notes: string) => void;
}

const COLORS = {
  frame: {
    stroke: '#FF4D4F', // Red
    fill: 'rgba(255, 77, 79, 0.25)',
  },
  support: {
    stroke: '#1890FF', // Blue
    fill: 'rgba(24, 144, 255, 0.25)',
  },
};

const ImageAnnotationTool: React.FC<ImageAnnotationToolProps> = ({
  visible,
  onClose,
  imageUrl,
  initialAnnotations,
  onSubmit,
  maxZoom = 10,
  minZoom = 0,
  title = 'Image Annotation Tool'
}) => {
  const { isMobile, isTablet } = useResponsive();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const [mode, setMode] = useState<any>('support'); // 'frame', 'support', or 'pan'
  const [scale, setScale] = useState<number>(1);
  const [offset, setOffset] = useState<Point>({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [dragStart, setDragStart] = useState<Point | null>(null);
  const [currentPolygon, setCurrentPolygon] = useState<Polygon>([]);
  // const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

  const isFullscreen = false;
  // const [mouseScreenPosition, setMouseScreenPosition] = useState<Point>({ x: 0, y: 0 });
  // const [showMagnifier, setShowMagnifier] = useState(false);
  // const [magnifierSize, setMagnifierSize] = useState<number>(160);
  // const magnifierSize = 160;
  // const magnifierZoom = 2.5;

  const [layers, setLayers] = useState<any>({
    frame: {
      polygons: initialAnnotations?.frame || [],
      color: COLORS.frame.stroke,
      fillColor: COLORS.frame.fill,
      label: 'Frame',
      visible: true,
    },
    support: {
      polygons: initialAnnotations?.support || [],
      color: COLORS.support.stroke,
      fillColor: COLORS.support.fill,
      label: 'Support',
      visible: true,
    },
  });

  useEffect(() => {
    if (!visible) {
      return;
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = imageUrl;

    img.onload = () => {
      imgRef.current = img;

      const resizeCanvas = () => {
        if (canvasRef.current && containerRef.current) {
          const container = containerRef.current;
          const canvas = canvasRef.current;

          canvas.width = container.clientWidth;
          canvas.height = container.clientHeight;

          resetView();
        }
      };

      resizeCanvas();

      window.addEventListener('resize', resizeCanvas);

      return () => {
        window.removeEventListener('resize', resizeCanvas);
      };
    };
  }, [visible, imageUrl]);

  const draw = useCallback(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx || !imgRef.current) {
      return;
    }

    const img = imgRef.current;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.save();
    ctx.translate(offset.x, offset.y);
    ctx.scale(scale, scale);

    ctx.drawImage(img, 0, 0, img.width, img.height);

    Object.entries(layers).forEach(([, layer]: any) => {
      if (layer.visible) {
        layer.polygons.forEach((polygon: any) => {
          drawPolygon(ctx, polygon, layer.fillColor, layer.color);
        });
      }
    });

    if (currentPolygon.length > 0) {
      const currentColor = mode === 'frame' ? COLORS.frame : COLORS.support;
      drawPolygon(
        ctx,
        currentPolygon,
        currentColor.fill,
        currentColor.stroke,
        true
      );
    }
    ctx.restore();
  }, [layers, currentPolygon, mode, offset, scale]);

  useEffect(() => {
    draw();
  }, [draw]);

  const drawPolygon = (
    ctx: CanvasRenderingContext2D,
    points: Point[],
    fillStyle: string,
    strokeStyle: string,
    isCurrent = false
  ) => {
    if (points.length < 1 || !imgRef.current) {
      return;
    }

    ctx.fillStyle = fillStyle;
    ctx.strokeStyle = strokeStyle;

    const imgSizeRef = (imgRef.current.width + imgRef.current.height) / 2;

    const baseLineWidth = isCurrent
      ? Math.max(1, imgSizeRef * 0.002)
      : Math.max(0.8, imgSizeRef * 0.0015);
    ctx.lineWidth = baseLineWidth * (1 / Math.sqrt(scale));

    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';

    ctx.beginPath();
    points.forEach(({ x, y }, i) => {
      if (i === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    });

    if (points.length > 2 || !isCurrent) {
      ctx.closePath();
    }
    ctx.fill();
    ctx.stroke();

    points.forEach(({ x, y }) => {
      ctx.beginPath();
      const basePointSize = isCurrent
        ? Math.max(3, imgSizeRef * 0.005)
        : Math.max(2, imgSizeRef * 0.004);
      const pointSize = basePointSize * (1 / Math.sqrt(scale));

      ctx.arc(x, y, pointSize, 0, Math.PI * 2);
      ctx.fillStyle = strokeStyle;
      ctx.fill();
      ctx.strokeStyle = 'white';
      ctx.lineWidth = Math.max(0.5, imgSizeRef * 0.0008) * (1 / Math.sqrt(scale));
      ctx.stroke();
    });
  };

  const screenToImageCoords = (screenX: number, screenY: number): Point => {
    const rect = canvasRef.current?.getBoundingClientRect();
    if (!rect) {
      return { x: 0, y: 0 };
    }

    return {
      x: (screenX - rect.left - offset.x) / scale,
      y: (screenY - rect.top - offset.y) / scale,
    };
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    if (mode === 'pan') {
      setIsDragging(true);
      setDragStart({ x: e.clientX, y: e.clientY });
    } else if (mode !== 'pan' && e.button === 0) {
      if (!imgRef.current) {
        message.error('Image not loaded yet. Please wait.');
        return;
      }
      const { x, y } = screenToImageCoords(e.clientX, e.clientY);
      setCurrentPolygon((prev) => [...prev, { x, y }]);
    }
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (isDragging && dragStart) {
      const dx = e.clientX - dragStart.x;
      const dy = e.clientY - dragStart.y;
      setOffset((prev) => ({ x: prev.x + dx, y: prev.y + dy }));
      setDragStart({ x: e.clientX, y: e.clientY });
    }

    const rect = canvasRef.current?.getBoundingClientRect();
    if (!rect) {
      return;
    }

    // const x = e.clientX - rect.left;
    // const y = e.clientY - rect.top;
    // setMouseScreenPosition({ x, y });
    // setShowMagnifier(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setDragStart(null);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    setDragStart(null);
    // setShowMagnifier(false);
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault();
    if (e.touches.length === 1) {
      const touch = e.touches[0];

      if (mode === 'pan') {
        setIsDragging(true);
        setDragStart({ x: touch.clientX, y: touch.clientY });
      } else {
        if (!imgRef.current) {
          message.error('Image not loaded yet. Please wait.');
          return;
        }
        const imageCoords = screenToImageCoords(touch.clientX, touch.clientY);
        setCurrentPolygon(prev => [...prev, imageCoords]);
      }
    }
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    e.preventDefault();
    if (e.touches.length === 1 && isDragging) {
      const touch = e.touches[0];

      if (dragStart) {
        const dx = touch.clientX - dragStart.x;
        const dy = touch.clientY - dragStart.y;
        setOffset((prev) => ({ x: prev.x + dx, y: prev.y + dy }));
        setDragStart({ x: touch.clientX, y: touch.clientY });
      }
    }
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    e.preventDefault();
    setIsDragging(false);
    setDragStart(null);
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    const zoomFactor = e.deltaY < 0 ? 1.1 : 0.9;
    zoom(zoomFactor, { x: e.clientX, y: e.clientY });
  };

  const zoom = (factor: number, center?: Point) => {
    const newScale = Math.max(minZoom, Math.min(maxZoom, scale * factor));

    if (center && canvasRef.current) {
      const rect = canvasRef.current.getBoundingClientRect();
      const centerX = center.x - rect.left;
      const centerY = center.y - rect.top;

      const imgX = (centerX - offset.x) / scale;
      const imgY = (centerY - offset.y) / scale;

      setOffset({
        x: centerX - imgX * newScale,
        y: centerY - imgY * newScale,
      });
    }
    setScale(newScale);
  };

  const completeCurrentPolygon = () => {
    if (currentPolygon.length < 3) {
      message.warning('A polygon must have at least 3 points to be valid.');
      return;
    }

    setLayers((prev: any) => ({
      ...prev,
      [mode]: {
        ...prev[mode],
        polygons: [...prev[mode].polygons, currentPolygon],
      },
    }));
    setCurrentPolygon([]);
    message.success(`${mode.charAt(0).toUpperCase() + mode.slice(1)} polygon added.`);
  };

  // const undoLastPoint = () => {
  //   if (currentPolygon.length > 0) {
  //     setCurrentPolygon((prev) => prev.slice(0, -1));
  //   } else {
  //     message.info('No points to undo for the current polygon.');
  //   }
  // };

  const clearCurrentPolygon = () => {
    if (currentPolygon.length > 0) {
      setCurrentPolygon([]);
      message.info('Current polygon cleared.');
    }
  };

  const deleteLastAddedPolygon = () => {

    if (currentPolygon.length !== 0) {
      clearCurrentPolygon();
      return;
    }
    setLayers((prev: any) => {
      const currentLayer = prev[mode];

      // if (Object.values(layers).every((layer: any) => layer.polygons.length === 0)) {
      //   message.warning('No annotations to save. Please add polygons before saving.');
      //   return;
      // }

      if (currentLayer.polygons.length > 0) {
        message.success(`Last ${mode} polygon deleted.`);
        return {
          ...prev,
          [mode]: {
            ...currentLayer,
            polygons: currentLayer.polygons.slice(0, -1),
          },
        };
      }
      message.info(`No ${mode} polygons to delete.`);
      return prev;
    });
  };

  const resetView = () => {
    if (!imgRef.current || !canvasRef.current) {
      return;
    }

    const canvas = canvasRef.current;
    const img = imgRef.current;

    const scaleX = canvas.width / img.width;
    const scaleY = canvas.height / img.height;
    const newScale = Math.min(scaleX, scaleY);

    const newOffset = {
      x: (canvas.width - img.width * newScale) / 2,
      y: (canvas.height - img.height * newScale) / 2,
    };

    setScale(newScale);
    setOffset(newOffset);
    // message.info('View reset to fit image.');
  };

  // const toggleLayerVisibility = (layerKey: 'frame' | 'support') => {
  //   setLayers((prev: any) => ({
  //     ...prev,
  //     [layerKey]: {
  //       ...prev[layerKey],
  //       visible: !prev[layerKey].visible,
  //     },
  //   }));
  //   // message.info(`${layers[layerKey].label} layer visibility toggled.`);
  // };

  // const toggleFullscreen = () => {
  //   setIsFullscreen(!isFullscreen);
  //   // message.info(isFullscreen ? 'Exited fullscreen.' : 'Entered fullscreen.');
  // };

  const handleSubmit = () => {
    // if (currentPolygon.length >= 3) {
    //   completeCurrentPolygon();
    // }

    // if (Object.values(layers).every((layer: any) => layer.polygons.length === 0)) {
    //   message.warning('No annotations to save. Please add polygons before saving.');
    //   return;
    // }

    if (layers.support.polygons.length && layers.frame.polygons.length === 0) {
      message.warning('No frame annotations to save. Please add polygons before saving.');
      return;
    }

    if (layers.frame.polygons.length && layers.support.polygons.length === 0) {
      message.warning('No support annotations to save. Please add polygons before saving.');
      return;
    }

    if (onSubmit) {
      onSubmit({
        frame: layers.frame.polygons,
        support: layers.support.polygons,
      });

      if (layers.frame.polygons.length !== 0 && layers.support.polygons.length !== 0) {
        message.success('Annotations saved successfully!');
      }
    }
    onClose();
  };

  useEffect(() => {
    const handleResize = () => {
      if (canvasRef.current && containerRef.current && imgRef.current) {
        const container = containerRef.current;
        canvasRef.current.width = container.clientWidth;
        canvasRef.current.height = container.clientHeight;
        // resetView();
        draw();
      }
    };

    const observer = new MutationObserver(handleResize);
    const parentElement = containerRef.current?.parentElement;
    if (parentElement) {
      observer.observe(parentElement, {
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
    };
  }, [isFullscreen, draw]);

  // Render
  return (
    <Modal
      title={<Title level={4} style={{ margin: 0 }}>{title}</Title>}
      open={visible}
      onCancel={() => {
        handleSubmit();
      }}
      width={isMobile ? '100%' : isTablet ? '95%' : '95%'}
      style={{
        maxWidth: isMobile ? '100vw' : isTablet ? '95vw' : '90vw',
        top: isMobile ? 0 : 20
      }}
      footer={null}
      closable={!isFullscreen}
      className={`${isFullscreen ? 'fullscreen-modal' : 'screen-modal'} image-segment-modal`}
      centered={!isMobile && isFullscreen}
      maskClosable={!isFullscreen}
    >
      <Row
        gutter={isMobile ? [0, 8] : [16, 16]}
        style={{
          height: isMobile ? '0' : isFullscreen ? 'calc(100vh - 55px)' : '70vh'
        }}
        className='row-container image-segment-container'
      >
        {/* Left Panel: Controls */}
        <Col span={isMobile ? 24 : isTablet ? 8 : 6}>
          <Space direction="vertical" style={{ width: '100%' }} size={isMobile ? 'small' : 'middle'}>
            <Card size="small" title="Annotation Mode" className="annotation-mode-card">
              <Radio.Group
                onChange={(e) => setMode(e.target.value as 'frame' | 'support' | 'pan')}
                value={mode}
                buttonStyle="solid"
                size={isMobile ? 'middle' : 'large'}
                style={{ width: '100%' }}
              >
                <Row gutter={isMobile ? [4, 4] : [8, 8]}>
                  <Col span={12}>
                    <Radio.Button value="support" style={{ width: '100%', textAlign: 'center' }}>
                      <BorderOutlined /> Image
                    </Radio.Button>
                  </Col>
                  <Col span={12}>
                    <Radio.Button value="frame" style={{ width: '100%', textAlign: 'center' }}>
                      <PushpinOutlined /> Frame
                    </Radio.Button>
                  </Col>
                </Row>
              </Radio.Group>
            </Card>

            {/* <Card size="small" title="Layers">
              <Space direction="vertical" style={{ width: '100%' }}>
                {Object.entries(layers).map(([key, layer]: any) => (
                  <Row key={key} justify="space-between" align="middle">
                    <Col>
                      <Checkbox
                        checked={layer.visible}
                        onChange={() => toggleLayerVisibility(key as 'frame' | 'support')}
                        style={{ color: layer.color }}
                      >
                        {layer.visible ? <EyeOutlined /> : <EyeInvisibleOutlined />} {layer.label}
                      </Checkbox>
                    </Col>
                    <Col>
                      <Text strong>{layer.polygons.length}</Text>
                    </Col>
                  </Row>
                ))}
              </Space>
            </Card> */}
            {/* <Card size="small" title="Video Tutorial">
              <video
                src={video}
                controls
                style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '8px' }}
              >
                Your browser does not support the video tag.
              </video>
            </Card> */}
            {/* <Card size="small" title="Notes">
              <Input.TextArea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Add notes about this annotation..."
                rows={4}
              />
            </Card> */}
          </Space>
        </Col>

        {/* Right Panel: Image Canvas and Toolbar */}
        <Col span={isMobile ? 24 : isTablet ? 16 : 18}>
          <Card
            size="small"
            bodyStyle={{ padding: 0, height: '100%', display: 'flex', flexDirection: 'column' }}
            style={{ height: '100%' }}
            className="canvas-container-card"
          >
            {/* Toolbar */}
            <div
              className="image-segment-toolbar"
              style={{
                padding: isMobile ? '12px 16px' : '8px 16px',
                borderBottom: '1px solid #f0f0f0',
                // display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: isMobile ? '8px' : '8px'
              }}
            >
              {!isMobile ? (
                <Row gutter={[16, 16]} align="middle">
                  {/* Zoom Controls */}
                  <Col xs={24} sm={24} md={16} lg={18} xl={18}>
                    <Row align="middle" gutter={[8, 8]}>
                      <Col>
                        <Tooltip title="Zoom Out">
                          <Button
                            size="middle"
                            icon={<ZoomOutOutlined />}
                            onClick={() => zoom(0.8)}
                            className="zoom-button"
                          />
                        </Tooltip>
                      </Col>

                      <Col flex="1">
                        <Slider
                          min={minZoom * 100}
                          max={maxZoom * 100}
                          onChange={(value: number) => setScale(value / 100)}
                          value={scale * 100}
                          tooltip={{ formatter: (val) => `${val}%` }}
                          className="zoom-slider"
                        />
                      </Col>

                      <Col>
                        <Tooltip title="Zoom In">
                          <Button
                            size="middle"
                            icon={<ZoomInOutlined />}
                            onClick={() => zoom(1.2)}
                            className="zoom-button"
                          />
                        </Tooltip>
                      </Col>

                      <Col>
                        <Text style={{ fontSize: '14px', fontWeight: '500' }}>
                          {Math.round(scale * 100)}%
                        </Text>
                      </Col>
                    </Row>
                  </Col>

                  {/* Actions: Delete + Save */}
                  <Col xs={24} sm={24} md={8} lg={6} xl={6}>
                    <Row justify="end" align="middle" gutter={[8, 8]}>
                      <Col>
                        <Tooltip title="Delete Last Added Polygon">
                          <Button
                            size="middle"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={deleteLastAddedPolygon}
                            disabled={
                              currentPolygon.length < 3 &&
                              layers[mode === 'pan' ? 'frame' : mode].polygons.length === 0
                            }
                          />
                        </Tooltip>
                      </Col>
                      <Col>
                        <Button
                          size="middle"
                          className={currentPolygon.length < 3 ? '' : 'complete-button'}
                          type="primary"
                          icon={<SaveOutlined />}
                          onClick={completeCurrentPolygon}
                          disabled={currentPolygon.length < 3 || mode === 'pan'}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>

              ) : (
                // Mobile layout - zoom controls and actions in same row
                <Row gutter={[8, 8]} align="middle" justify="center" wrap={false} style={{ width: '100%' }}>
                  {/* Zoom Slider */}
                  <Col flex="auto" style={{ minWidth: 120 }}>
                    <Slider
                      min={minZoom * 100}
                      max={maxZoom * 100}
                      onChange={(value) => setScale(value / 100)}
                      value={scale * 100}
                      tooltip={{ formatter: (val) => `${val}%` }}
                      className="zoom-slider"
                    />
                  </Col>

                  {/* Zoom % */}
                  <Col>
                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                      {Math.round(scale * 100)}%
                    </Text>
                  </Col>

                  {/* Actions Button */}
                  <Col>
                    <Dropdown
                      menu={{
                        items: [
                          {
                            key: 'delete',
                            icon: <DeleteOutlined />,
                            label: 'Delete Last Polygon',
                            disabled:
                              currentPolygon.length < 3 &&
                              layers[mode === 'pan' ? 'frame' : mode].polygons.length === 0,
                            onClick: deleteLastAddedPolygon,
                            danger: true,
                          },
                          {
                            key: 'save',
                            icon: <SaveOutlined />,
                            label: 'Save Polygon',
                            disabled: currentPolygon.length < 3 || mode === 'pan',
                            onClick: completeCurrentPolygon,
                          },
                        ],
                      }}
                      trigger={['click']}
                      placement="bottomRight"
                    >
                      <Button size="middle" icon={<MoreOutlined />}>
                        Actions
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              )}
            </div>

            {/* Canvas Container */}
            <div
              ref={containerRef}
              className="image-segment-canvas-container"
              style={{
                flexGrow: 1,
                position: 'relative',
                overflow: 'hidden',
                backgroundColor: '#f0f2f5',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: mode === 'pan' ? (isDragging ? 'grabbing' : 'grab') : 'crosshair',
                height: isMobile ? '62vh' : isTablet ? '60vh' : '70vh',
                minHeight: isMobile ? '300px' : '400px',
              }}

              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseLeave}
              onWheel={handleWheel}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <canvas
                ref={canvasRef}
                style={{
                  display: imgRef.current ? 'block' : 'none',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  userSelect: 'none',
                  touchAction: 'none', // Prevent default touch behaviors
                }}
                width={isMobile ? 600 : isTablet ? 800 : isFullscreen ? 1200 : 858}
                height={isMobile ? 400 : isTablet ? 600 : isFullscreen ? 800 : 611}
              />
              {!imgRef.current && (
                <Text type="secondary">Loading image...</Text>
              )}

              {/* {imgRef.current && mode !== 'pan' && (
                <Magnifier
                  image={imgRef.current}
                  visible={showMagnifier}
                  mouseScreenPosition={mouseScreenPosition}
                  offset={offset}
                  scale={scale}
                  zoom={magnifierZoom}
                  size={magnifierSize}
                  drawPolygon={drawPolygon}
                  layers={layers}
                  currentPolygon={currentPolygon}
                  mode={mode}
                />
              )} */}
            </div>
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export default ImageAnnotationTool;